export default __webpack_public_path__ + "static/media/gnosis3.f416cf71.png";